<template>
  <div class="max-w-[90vw] mx-auto">
    <div class="w-full flex justify-end align-center">
      <v-container class="onest-font">
        <a
          @click.prevent="goBack"
          style="color: inherit; cursor: pointer; text-decoration: none"
          class="d-flex align-center d-inline-flex"
        >
          <v-icon size="20" class="mr-1">mdi-arrow-u-left-bottom</v-icon>
          <span style="text-decoration: underline">voltar</span>
        </a>
        <h1 class="font-bold mt-2 text-5xl">Escopo de Validação</h1>
        <div class="text-lg mt-2 flex flex-col">
          <span v-if="projeto" class="font-bold">
            Projeto: <span class="font-medium">{{ projeto.nome }}</span>
          </span>
          <span v-if="projeto" class="font-bold">
            Validação:
            <span class="font-medium">{{ projeto.validacao }}</span>
          </span>
        </div>
      </v-container>
      <v-container class="onest-font d-flex justify-end gap-2">
        <v-btn
          variant="outlined"
          prepend-icon="mdi-import"
          color="primary"
          @click="openModalImportar"
        >
          Importar Escopo
        </v-btn>
      </v-container>
    </div>
    <v-container>
      <div class="search-bar w-full pb-4">
        <v-text-field
          v-model="searchQuery"
          variant="solo"
          flat
          hide-details
          class="search-input"
          placeholder="Buscar casos de uso ou funcionalidades do escopo"
          aria-label="Buscar casos de uso ou funcionalidades do escopo"
          append-inner-icon="mdi-magnify"
        ></v-text-field>
      </div>
      <div
        v-if="carregando"
        class="py-12 text-center text-gray-500 font-medium"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-circular>
        <p>Carregando escopo de validação...</p>
      </div>

      <v-row v-else>
        <v-col cols="12" md="4">
          <div class="bg-white rounded-lg px-6 py-4 h-full">
            <div class="d-flex justify-between">
              <h2 class="text-xl font-bold mb-4">Casos de Uso Disponíveis</h2>
              <h2
                class="text-xl font-bold mb-4 px-3 py-1 rounded-full bg-gray-200"
              >
                {{ totalCasosUsos }}
              </h2>
            </div>
            <div
              v-if="disponiveis.length === 0"
              class="text-center text-gray-500 py-10 border border-dashed border-gray-200 rounded-lg"
            >
              Nenhum caso de uso disponível.
            </div>
            <v-list
              v-else
              class="bg-transparent pa-0 max-h-[60vh] overflow-y-auto pr-2"
              role="navigation"
              aria-label="Navegação de Casos de Uso Disponíveis"
            >
              <v-list-item
                v-for="element in filteredDisponiveis"
                :key="element.id"
                :class="[
                  'mb-3 transition-colors border rounded-lg',
                  isSelecionado(element.id)
                    ? 'bg-blue-50 border-blue-200 opacity-70'
                    : 'bg-gray-100 hover:bg-gray-200 cursor-pointer',
                ]"
                elevation="0"
                @click="
                  !isSelecionado(element.id) && adicionarAoEscopo(element)
                "
              >
                <div
                  class="d-flex align-center py-2 w-100 justify-space-between"
                >
                  <span
                    :class="[
                      'font-medium',
                      !isSelecionado(element.id) ? 'text-gray-700' : '',
                    ]"
                    :style="isSelecionado(element.id) ? 'color: #5568ac;' : ''"
                  >
                    {{ element.nome }}
                  </span>
                  <v-icon
                    :class="
                      isSelecionado(element.id)
                        ? 'text-blue-600'
                        : 'text-gray-500'
                    "
                  >
                    {{
                      isSelecionado(element.id)
                        ? 'mdi-check-circle'
                        : 'mdi-chevron-right'
                    }}
                  </v-icon>
                </div>
              </v-list-item>
            </v-list>
          </div>
        </v-col>

        <v-col cols="12" md="8">
          <div class="bg-white rounded-lg px-6 py-4 h-full">
            <div class="d-flex justify-between align-center mb-4">
              <h2 class="text-xl font-bold">Escopo Selecionado</h2>
              <h2
                class="text-xl font-bold px-3 py-1 rounded-full bg-blue-100"
                style="color: #5568ac"
              >
                {{ filteredSelecionadosCount }}
              </h2>
            </div>

            <v-expansion-panels
              variant="accordion"
              v-if="selecionados.length > 0"
              class="max-h-[60vh] overflow-y-auto pr-2"
            >
              <v-expansion-panel
                v-for="(item, index) in selecionados"
                :key="item.uuid"
                v-show="matchSearch(item)"
                :class="[
                  'mb-2 rounded-xl border transition-colors',
                  !item.idEscopo
                    ? 'bg-amber-50 border-amber-200'
                    : 'bg-gray-100 border-gray-200',
                ]"
                elevation="0"
              >
                <v-expansion-panel-title
                  :class="[
                    'font-bold',
                    !item.idEscopo ? 'text-amber-900' : 'text-gray-900',
                  ]"
                >
                  {{ item.casoUso.nome }}
                  <template #actions>
                    <v-btn
                      v-if="!item.isEditing"
                      icon
                      size="small"
                      variant="text"
                      :color="!item.idEscopo ? 'amber-darken-4' : 'primary'"
                      @click.stop="editarFormulario(index)"
                      aria-label="Editar escopo"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      color="error"
                      @click.stop="removerDoEscopo(index)"
                      aria-label="Remover escopo"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-icon :color="!item.idEscopo ? 'amber-darken-3' : ''"
                      >mdi-chevron-down</v-icon
                    >
                  </template>
                </v-expansion-panel-title>
                <v-expansion-panel-text
                  :class="
                    !item.idEscopo ? 'pt-4 bg-amber-50/10' : 'pt-4 bg-white'
                  "
                >
                  <v-form @submit.prevent="salvarFormulario(index)">
                    <!-- MODO DE EDIÇÃO -->
                    <div v-if="item.isEditing">
                      <p
                        :class="[
                          'font-semibold text-sm',
                          !item.idEscopo ? 'text-amber-900' : 'text-gray-700',
                        ]"
                      >
                        FUNCIONALIDADE *
                      </p>
                      <v-text-field
                        v-model="item.funcionalidade"
                        placeholder="Qual o nome da funcionalidade?"
                        variant="solo"
                        density="compact"
                        class="mb-2 mt-1"
                      ></v-text-field>

                      <p
                        :class="[
                          'font-semibold text-sm mt-4',
                          !item.idEscopo ? 'text-amber-900' : 'text-gray-700',
                        ]"
                      >
                        OBJETIVO *
                      </p>
                      <v-textarea
                        v-model="item.objetivo"
                        placeholder="Qual o objetivo?"
                        variant="solo"
                        density="comfortable"
                        rows="2"
                        class="mb-2 mt-1"
                      ></v-textarea>

                      <p
                        :class="[
                          'font-semibold text-sm mt-4',
                          !item.idEscopo ? 'text-amber-900' : 'text-gray-700',
                        ]"
                      >
                        COMO ACESSAR
                        <span v-if="!item.imagens || item.imagens.length === 0"
                          >*</span
                        >
                      </p>
                      <v-textarea
                        v-model="item.comoAcessar"
                        placeholder="Descreva o caminho para essa funcionalidade"
                        variant="solo"
                        density="comfortable"
                        rows="2"
                        class="mb-2 mt-1"
                      ></v-textarea>

                      <p
                        :class="[
                          'font-semibold text-sm mt-4',
                          !item.idEscopo ? 'text-amber-900' : 'text-gray-700',
                        ]"
                      >
                        IMAGENS DE REFERÊNCIA
                        <span
                          v-if="
                            !item.comoAcessar || item.comoAcessar.trim() === ''
                          "
                          >*</span
                        >
                      </p>
                      <v-file-input
                        v-model="item.imagens"
                        label="Clique para selecionar ou arraste imagens para esta área..."
                        variant="solo"
                        density="compact"
                        multiple
                        prepend-icon="mdi-camera"
                        accept="image/*"
                        class="mb-2 w-5xl mt-1"
                        hint="Você pode selecionar várias imagens. A ordem de seleção importa."
                        persistent-hint
                      ></v-file-input>

                      <draggable
                        v-if="item.imagens && item.imagens.length"
                        v-model="item.imagens"
                        item-key="name"
                        class="d-flex flex-wrap gap-2 mb-4"
                        :animation="200"
                      >
                        <template #item="{ element, index: imgIndex }">
                          <div
                            class="border border-blue-300 rounded bg-blue-50 p-2 d-flex flex-column align-center shadow-sm position-relative"
                            style="cursor: grab"
                          >
                            <v-icon
                              icon="mdi-drag"
                              class="position-absolute text-white bg-black bg-opacity-50 rounded-circle"
                              style="
                                top: 4px;
                                left: 4px;
                                z-index: 10;
                                padding: 12px;
                              "
                              size="x-small"
                            ></v-icon>
                            <img
                              :src="getPreviewUrl(element)"
                              class="object-cover rounded"
                              style="width: 120px; height: 120px"
                              alt="Preview"
                            />
                            <span
                              class="text-xs text-blue-800 mt-2 text-truncate font-weight-bold"
                              style="max-width: 120px"
                              :title="element.name || element.link_imagem"
                            >
                              {{ imgIndex + 1 }}.
                              {{ element.name || 'Imagem Salva' }}
                            </span>
                          </div>
                        </template>
                      </draggable>
                    </div>

                    <!-- MODO DE VISUALIZAÇÃO -->
                    <div v-else class="text-gray-800">
                      <p class="text-xs font-bold text-gray-500 mb-1">
                        FUNCIONALIDADE
                      </p>
                      <p class="text-lg font-medium mb-4">
                        {{ item.funcionalidade || 'Não informada' }}
                      </p>

                      <p class="text-xs font-bold text-gray-500 mb-1">
                        OBJETIVO
                      </p>
                      <p class="mb-4 whitespace-pre-wrap">
                        {{ item.objetivo || 'Não informado' }}
                      </p>

                      <p class="text-xs font-bold text-gray-500 mb-1">
                        COMO ACESSAR
                      </p>
                      <p class="mb-4 whitespace-pre-wrap">
                        {{ item.comoAcessar || 'Não informado' }}
                      </p>

                      <p class="text-xs font-bold text-gray-500 mb-2">
                        IMAGENS DE REFERÊNCIA
                      </p>
                      <div
                        v-if="item.imagens && item.imagens.length"
                        class="d-flex flex-wrap gap-4 mt-2"
                      >
                        <div
                          v-for="(img, imgIndex) in item.imagens"
                          :key="imgIndex"
                          class="border border-gray-300 rounded bg-white p-2 d-flex flex-column align-center shadow-sm"
                        >
                          <img
                            :src="getPreviewUrl(img)"
                            class="object-cover rounded"
                            style="width: 150px; height: 150px"
                            alt="Preview"
                          />
                          <span
                            class="text-xs text-gray-600 mt-2 text-truncate"
                            style="max-width: 150px"
                            :title="img.name"
                            >{{ imgIndex + 1 }}. {{ img.name }}</span
                          >
                        </div>
                      </div>
                      <p v-else class="text-gray-500 text-sm italic mb-2">
                        Nenhuma imagem anexada.
                      </p>
                    </div>

                    <div class="d-flex justify-end mt-2" v-if="item.isEditing">
                      <v-btn
                        color="primary"
                        type="submit"
                        prepend-icon="mdi-content-save"
                      >
                        Salvar
                      </v-btn>
                    </div>
                  </v-form>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
            <div
              v-else
              class="text-center text-gray-500 py-10 border-2 border-dashed border-gray-300 rounded-lg"
            >
              Nenhuma funcionalidade criada. Clique num Caso de Uso ao lado para
              iniciar.
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <ModalImportValidationScope
      v-model:ativo="modalImportarAtivo"
      :id-projeto="idProjeto"
      @importar-dados="importarEscopo"
    />
  </div>
</template>

<script>
/**
 * @module ValidationScope
 * @desc Tela para o usuário montar, visualizar e editar o Escopo de Validação.
 * @vue-data {string} [searchQuery=''] - Texto digitado na barra de pesquisa.
 * @vue-data {Object} projeto - Informações básicas do projeto.
 * @vue-data {string} idProjeto - O identificador numérico do projeto.
 * @vue-data {Array} disponiveis - Casos de uso vindos da API.
 * @vue-data {Array} selecionados - Casos de uso adicionados ao escopo pelo usuário.
 * @vue-computed {Array} filteredDisponiveis - Casos de uso filtrados pela barra de pesquisa.
 */
import axios from 'axios';
import draggable from 'vuedraggable';

import ModalImportValidationScope from '@/components/dialogs/ModalImportValidationScope.vue';
import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    draggable,
    ModalImportValidationScope,
  },
  /**
   * @description Estados do componente.
   * @returns {Object} Estados do componente.
   * @property {string} searchQuery - Campo de pesquisa.
   * @property {Object} projeto - Projeto.
   * @property {string} idProjeto - ID do projeto.
   * @property {Array} disponiveis - Casos de uso disponíveis.
   * @property {number} totalCasosUsos - Total de casos de uso.
   * @property {Array} selecionados - Casos de uso selecionados.
   * @property {boolean} modalImportarAtivo - Estado do modal de importação de escopo.
   */
  data() {
    return {
      searchQuery: '',
      projeto: { nome: 'Carregando...', validacao: 'Carregando...' },
      idProjeto: '',
      disponiveis: [],
      totalCasosUsos: 0,
      selecionados: [],
      modalImportarAtivo: false,
      carregando: true,
    };
  },
  async mounted() {
    this.idProjeto = this.$route.params.idProjeto;
    this.carregando = true;
    try {
      await Promise.all([
        this.fetchProjetoInfo(),
        this.fetchUseCasesByProject(),
        this.fetchEscopoSalvo(),
      ]);
    } catch (error) {
      console.error('Erro ao buscar dados do escopo:', error);
    } finally {
      this.carregando = false;
    }
  },
  computed: {
    /**
     * @description Filtra a lista de casos de uso disponíveis em tempo real
     * com base no texto digitado na barra de pesquisa (searchQuery).
     * @returns {Array<Object>} Lista de casos de uso que correspondem à pesquisa.
     */
    filteredDisponiveis() {
      if (!this.searchQuery) {
        return this.disponiveis;
      }
      const query = this.searchQuery.toLowerCase();

      return this.disponiveis.filter((element) =>
        element.nome.toLowerCase().includes(query),
      );
    },
    /**
     * @description Conta quantos itens selecionados correspondem à pesquisa.
     * @returns {number} Quantidade de itens visíveis.
     */
    filteredSelecionadosCount() {
      if (!this.searchQuery) {
        return this.selecionados.length;
      }

      return this.selecionados.filter((item) => this.matchSearch(item)).length;
    },
  },
  methods: {
    /**
     * Verifica se um escopo selecionado corresponde à pesquisa.
     * @param {Object} item - O item do escopo selecionado.
     * @returns {boolean} Se o item deve ser exibido.
     */
    matchSearch(item) {
      if (!this.searchQuery) {
        return true;
      }
      const query = this.searchQuery.toLowerCase();
      const nome = (item.casoUso?.nome || '').toLowerCase();
      const funcionalidade = (item.funcionalidade || '').toLowerCase();

      return nome.includes(query) || funcionalidade.includes(query);
    },
    /**
     * Gera um ID único universal (UUID) para identificar os casos de uso.
     * @returns {string} ID único universal gerado.
     */
    generateUUID() {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    },
    /**
     * Obtém a URL de preview de uma imagem.
     *
     * @param {File|string} file - Arquivo ou URL da imagem.
     * @returns {string} URL de preview da imagem.
     */
    getPreviewUrl(file) {
      if (!file) {
        return '';
      }

      if (file instanceof File) {
        return URL.createObjectURL(file);
      }

      // Se a imagem veio do banco, ela possui a propriedade link_imagem (URL do S3)
      if (file.link_imagem) {
        return file.link_imagem;
      }

      return '';
    },
    /**
     * Verifica se o caso de uso já foi adicionado ao escopo.
     * @param {number|string} id - ID do caso de uso.
     * @returns {boolean}
     */
    isSelecionado(id) {
      return this.selecionados.some((s) => s.casoUso.id === id);
    },
    /**
     * Adiciona um caso de uso ao escopo do projeto.
     *
     * @param {Object} casoUso - Caso de uso a ser adicionado.
     * @returns {void}
     */
    adicionarAoEscopo(casoUso) {
      if (this.isSelecionado(casoUso.id)) {
        this.$toast.warning('Este caso de uso já foi adicionado ao escopo.');

        return;
      }
      this.selecionados.unshift({
        uuid: this.generateUUID(),
        casoUso: casoUso,
        funcionalidade: '',
        objetivo: '',
        comoAcessar: '',
        imagens: [],
        isEditing: true,
      });
      this.$toast.info('Formulário iniciado!');
    },
    /**
     * Remove um caso de uso do escopo do projeto baseado no índice.
     *
     * @param {number} index Índice do caso de uso a ser removido
     */
    removerDoEscopo(index) {
      const escopo = this.selecionados[index];

      if (escopo.idEscopo) {
        // Se já existe no banco, chama a API para deletar
        axios
          .delete(`${apiUrl}/api/v1/escopos/${escopo.idEscopo}`, {
            headers: { Authorization: `Bearer ${store.state.token}` },
          })
          .then(() => {
            this.selecionados.splice(index, 1);
            this.$toast.success('Escopo removido com sucesso!');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao remover o escopo do banco de dados.');
          });
      } else {
        // Se não foi salvo ainda, apenas remove da tela
        this.selecionados.splice(index, 1);
      }
    },
    /**
     * @description Edita um caso de uso no escopo do projeto.
     * @param {number} index - Índice do caso de uso a ser editado.
     * @returns {void}
     */
    editarFormulario(index) {
      this.selecionados[index].isEditing = true;
      // TODO: metodo POST quando salvar
    },
    /**
     * @description Salva um caso de uso no escopo do projeto.
     * @param {number} index - Índice do caso de uso a ser salvo.
     * @returns {void}
     */
    salvarFormulario(index) {
      const escopo = this.selecionados[index];

      if (!escopo.funcionalidade || escopo.funcionalidade.trim() === '') {
        this.$toast.error('O campo Funcionalidade é obrigatório.');

        return;
      }
      if (!escopo.objetivo || escopo.objetivo.trim() === '') {
        this.$toast.error('O campo Objetivo é obrigatório.');

        return;
      }
      const temImagens = escopo.imagens && escopo.imagens.length > 0;
      const temComoAcessar =
        escopo.comoAcessar && escopo.comoAcessar.trim() !== '';
      if (!temImagens && !temComoAcessar) {
        this.$toast.error(
          'Você deve preencher o campo "Como Acessar" ou adicionar pelo menos uma "Imagem de Referência".',
        );

        return;
      }

      const formData = new FormData();
      formData.append('funcionalidade', escopo.funcionalidade);
      formData.append('objetivo', escopo.objetivo);
      formData.append('como_acessar', escopo.comoAcessar);

      // Adiciona todas as imagens anexadas no array 'imagens' do FormData
      if (escopo.imagens && escopo.imagens.length > 0) {
        escopo.imagens.forEach((img) => {
          formData.append('imagens', img);
        });
      }

      // Desativa a edição enquanto salva (opcional, mas previne cliques duplos)
      escopo.isEditing = false;

      // Chama a API correspondente (POST se for novo, PUT se já existir)
      if (escopo.idEscopo) {
        // Modo de Atualização (PUT)
        // OBS: Enviamos apenas JSON, pois o backend não tem suporte a imagens no PUT
        axios
          .put(
            `${apiUrl}/api/v1/escopos/${escopo.idEscopo}`,
            {
              funcionalidade: escopo.funcionalidade,
              objetivo: escopo.objetivo,
              comoAcessar: escopo.comoAcessar,
            },
            {
              headers: { Authorization: `Bearer ${store.state.token}` },
            },
          )
          .then(() => {
            this.$toast.success('Funcionalidade salva com sucesso');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao atualizar o escopo.');
            escopo.isEditing = true; // Volta ao modo de edição em caso de erro
          });
      } else {
        // Modo de Criação (POST)
        axios
          .post(
            `${apiUrl}/api/v1/casos-de-uso/${escopo.casoUso.id}/escopos`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
                'Content-Type': 'multipart/form-data', // Essencial para envio de arquivos
              },
            },
          )
          .then((res) => {
            this.$toast.success('Funcionalidade salva com sucesso');
            // Atualiza o ID do escopo para referenciar o banco (note que no db é id_escopo)
            escopo.idEscopo = res.data.id_escopo;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar o formulário.');
            escopo.isEditing = true; // Volta ao modo de edição em caso de erro
          });
      }
    },
    /**
     * Busca os dados do projeto no backend para preencher o cabeçalho dinamicamente.
     */
    fetchProjetoInfo() {
      return axios
        .get(`${apiUrl}/projetos/listaprojeto/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.projeto.nome = res.data.nome || 'Projeto Desconhecido';

            // Pega o nome da validação mais recente (se existir)
            if (
              res.data.tb_projetos_envolvidos &&
              res.data.tb_projetos_envolvidos.length > 0
            ) {
              this.projeto.validacao =
                res.data.tb_projetos_envolvidos[0].tb_validacao.nome_validacao;
            } else {
              this.projeto.validacao = 'Nenhuma validação ativa';
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar dados do projeto:', error);
        });
    },
    /**
     * @description Busca os casos de uso do projeto na API.
     * @returns {void}
     */
    fetchUseCasesByProject() {
      return axios
        .get(apiUrl + '/api/v1/productBacklog/projeto/' + this.idProjeto, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.disponiveis = res.data.useCases.map((uc) => ({
            id: uc.id_caso_de_uso,
            nome: `${uc.identificador} - ${uc.nome}`,
          }));
          this.totalCasosUsos = this.disponiveis.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // Função para buscar o escopo já salvo e popular a lista "selecionados"
    fetchEscopoSalvo() {
      return axios
        .get(apiUrl + '/api/v1/projetos/' + this.idProjeto + '/escopos', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          // A API retorna um array de objetos tb_escopo_validacao (veja o listarEscoposPorProjeto no backend)
          this.selecionados = res.data
            .filter((escopo) => escopo.tb_caso_de_uso) // Ignora registros órfãos antigos
            .map((escopo) => ({
              uuid: this.generateUUID(),
              idEscopo: escopo.id_escopo,
              casoUso: {
                id: escopo.tb_caso_de_uso.id_caso_de_uso,
                nome: `${escopo.tb_caso_de_uso.identificador} - ${escopo.tb_caso_de_uso.nome}`,
              },
              funcionalidade: escopo.funcionalidade,
              objetivo: escopo.objetivo,
              comoAcessar: escopo.como_acessar,
              imagens: escopo.tb_imagem_acesso || [],
              isEditing: false,
            }));
        })
        .catch((error) => {
          console.error('Erro ao buscar escopo salvo:', error);
        });
    },
    /**
     * @description Abre o modal de importação de escopo.
     * @returns {void}
     */
    openModalImportar() {
      this.modalImportarAtivo = true;
    },
    /**
     * @description Importa o escopo do projeto.
     * @param {Object} validacao - Dados da validação selecionada no modal.
     * @returns {void}
     */
    importarEscopo(validacao) {
      if (!validacao || !validacao.id) {
        this.$toast.warning('Validação inválida selecionada.');

        return;
      }

      // Chama a API do backend que mapeia e copia os dados no banco
      axios
        .post(
          `${apiUrl}/api/v1/validacoes/${this.idProjeto}/importar`,
          { idValidacaoOrigem: validacao.id },
          { headers: { Authorization: `Bearer ${store.state.token}` } },
        )
        .then(async (res) => {
          const quantidade = res.data.quantidade_importada || 0;
          this.$toast.success(
            `${quantidade} funcionalidades importadas com sucesso da ${validacao.nome}!`,
          );

          // Atualiza a tela com os dados reais recém-copiados no banco
          this.carregando = true;
          try {
            await this.fetchEscopoSalvo();
          } finally {
            this.carregando = false;
          }
        })
        .catch((error) => {
          console.error('Erro ao importar escopo:', error);
          if (error.response && error.response.status === 404) {
            this.$toast.error(
              'A validação de origem não foi encontrada ou está vazia.',
            );
          } else {
            this.$toast.error('Erro no servidor ao tentar importar o escopo.');
          }
        });
    },
    /**
     * @description Retorna para a página anterior.
     * @returns {void}
     */
    goBack() {
      this.$router.push('/project-validation/' + this.$route.params.idProjeto);
    },
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}

.search-bar:deep(.v-field) {
  @apply !rounded-full !bg-white !shadow-md;
}
.search-bar:deep(.v-input__control) {
  @apply !bg-transparent;
}
</style>
